'use client';

import { CSSProperties } from 'react';
import { useTranslations } from 'next-intl';
import { CustomImage as Image } from '../..';
import { addBtnGrey, addBtnGrey2 } from '../UnderstandYourSleep/icons';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import styles from './MobileRecoveryComponent.module.css';

export const MobileRecoveryComponent = ({
  className,
  handleDynamicRecovery,
  handleStress,
  handleSkinTemperature,
  handleHRVfactor,
}: {
  className?: string;
  handleDynamicRecovery?: any;
  handleStress?: any;
  handleSkinTemperature?: any;
  handleHRVfactor?: any;
}) => {
  const t = useTranslations('ring');
  return (
    <section
      className={className ? `${styles.root} ${className}` : styles.root}
      aria-labelledby="mobile-recovery-section-heading"
    >
      <div className="head">
        {/* <h2>
          The edge in your recovery game
          </h2>
          <p>
            Dynamic Recovery analyzes key physiological markers for a real-time
            Recovery Score. Understand how sleep, stress rhythm, skin
            temperature, and HRV affect your body&apos;s restoration. Improve
            recovery with power naps and breathwork techniques.
          </p> */}
        <h2 id="mobile-recovery-section-heading">
          {t('ring.bentoRecoverySection.head')}
        </h2>
        <p>{t('ring.bentoRecoverySection.subHead')}</p>
      </div>
      <div className="sleep-items-container u-hide-scrollbar">
        <div className="items">
          <div
            className="item recovery"
            style={
              {
                '--recovery-bg': `url(${getCompressedAssetUrl(
                  '/web_v2/ring-buy/recovery/png/recoveryAsset.png',
                )})`,
              } as CSSProperties
            }
          >
            <div className="content">
              {/* <h4>Dynamic Recovery</h4>
                <h3>Track your recovery changes throughout the day</h3> */}
              <h4 id="mobile-dynamic-recovery-title">
                {t('ring.bentoRecoverySection.dynamicRecoveryCard.title')}
              </h4>
              <h3>
                {t('ring.bentoRecoverySection.dynamicRecoveryCard.subtitle')}
              </h3>
            </div>
            <button
              className="expand"
              onClick={handleDynamicRecovery}
              aria-label={t(
                'mobileRecoveryComponent.button.ariaLabel.learnMoreAbout',
              )}
              aria-describedby="mobile-dynamic-recovery-title"
            >
              {addBtnGrey2}
            </button>
          </div>
          <div className="item temperature">
            <div className="content">
              {/* <h4>Skin temperature</h4>
                <h3>Early indicatores with temperature metrics</h3> */}
              <h4 id="mobile-skin-temperature-title">
                {t('ring.bentoRecoverySection.skinTemperatureCard.title')}
              </h4>
              <h3>
                {t('ring.bentoRecoverySection.skinTemperatureCard.subtitleA')}{' '}
                {t('ring.bentoRecoverySection.skinTemperatureCard.subtitleB')}{' '}
                {t('ring.bentoRecoverySection.skinTemperatureCard.subtitleC')}
              </h3>
              {/* <div className="sleep-graph">{SleepGraphResp}</div> */}
              <div
                className="img-container"
                role="img"
                aria-label={t('mobileRecoveryComponent.content.ariaLabel')}
              >
                <Image
                  src={'web_v2/ring-buy/recovery/svg/tempRes.svg'}
                  fill
                  alt=""
                  className="temperature-img"
                  aria-hidden="true"
                />
              </div>
            </div>
            <button
              className="expand"
              onClick={handleSkinTemperature}
              aria-label={t(
                'mobileRecoveryComponent.button.ariaLabel.learnMoreAbout2',
              )}
              aria-describedby="mobile-skin-temperature-title"
            >
              {addBtnGrey}
            </button>
          </div>
          <div className="item hrv">
            <div className="content">
              {/* <h4>The Hrv factor</h4>
                <h3>
                  Continous hrv
                  <br /> monitoring
                </h3> */}
              <h4 id="mobile-hrv-factor-title">
                {t('ring.bentoRecoverySection.hrvCard.title')}
              </h4>
              <h3>
                {t('ring.bentoRecoverySection.hrvCard.subtitleA')}
                <br /> {t('ring.bentoRecoverySection.hrvCard.subtitleB')}
              </h3>
              <div
                className="img-container"
                role="img"
                aria-label={t('mobileRecoveryComponent.content.ariaLabelHrv')}
              >
                <Image
                  src={'web_v2/ring-buy/recovery/svg/hrvFactor.svg'}
                  fill
                  alt=""
                  className="contributorImg"
                  aria-hidden="true"
                />
              </div>
            </div>
            <button
              className="expand"
              onClick={handleHRVfactor}
              aria-label={t(
                'mobileRecoveryComponent.button.ariaLabel.learnMoreAbout3',
              )}
              aria-describedby="mobile-hrv-factor-title"
            >
              {addBtnGrey}
            </button>
          </div>
          <div
            className="item stress"
            style={
              {
                '--stress-bg': `url(${getCompressedAssetUrl(
                  '/web_v2/ring-buy/recovery/png/stress.png',
                )})`,
              } as CSSProperties
            }
          >
            <div className="content">
              <h4 id="mobile-stress-title">
                {t('ring.bentoRecoverySection.stressCard.title')}
              </h4>
              <h3>
                {t('ring.bentoRecoverySection.stressCard.subtitleA')}{' '}
                {t('ring.bentoRecoverySection.stressCard.subtitleB')}
              </h3>
            </div>
            <button
              className="expand"
              onClick={handleStress}
              aria-label={t(
                'mobileRecoveryComponent.button.ariaLabel.learnMoreAbout4',
              )}
              aria-describedby="mobile-stress-title"
            >
              {addBtnGrey2}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
